function view (path) {
  return () => import(/* webpackChunkName: 'scm-v1' */ '@/views/scm/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RSupplyChainManager = [
  {
    path: '/scm/dashboard',
    component: view('Dashboard'),
    name: 'scm.dashboard',
    authorizedRole: 'scm'
  }
]

const RSCMPurchaseOrders = [
  {
    path: '/scm/purchase-orders/approvals/:approver?/:status?',
    component: view('approvals/purchase-orders/Base'),
    name: 'scm.purchase-orders.approvals',
    authorizedRole: 'scm',
    meta: {
      breadcrumb: [
        {
          text: 'Supply Chain Manager'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  }
]

const RSCMInterWarehouses = [
  {
    path: '/scm/inter-warehouses/approvals/:approver?/:status?',
    component: view('approvals/inter-warehouses/Base'),
    name: 'scm.inter-warehouses.approvals',
    authorizedRole: 'scm',
    meta: {
      breadcrumb: [
        {
          text: 'Supply Chain Manager'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  }
]

const RSCMAtws = [
  {
    path: '/scm/atws/approvals/:approver?/:status?',
    component: view('approvals/atws/Base'),
    name: 'scm.atws.approvals',
    authorizedRole: 'scm',
    meta: {
      breadcrumb: [
        {
          text: 'Supply Chain Manager'
        },
        {
          text: 'ATWs'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  }
]

export default RSupplyChainManager.concat(
  RSCMPurchaseOrders,
  RSCMInterWarehouses,
  RSCMAtws
)
